export default __webpack_public_path__ + "static/7-0273c9598956f21e205a884940eb675f.png";